import { render, staticRenderFns } from "./ActionPanewsSetVar.vue?vue&type=template&id=641e12d4&scoped=true&"
import script from "./ActionPanewsSetVar.vue?vue&type=script&lang=js&"
export * from "./ActionPanewsSetVar.vue?vue&type=script&lang=js&"
import style0 from "./ActionPanewsSetVar.vue?vue&type=style&index=0&id=641e12d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641e12d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
